<template>
  <div class="hefei-bg-f5">
    <div class="container-wrap-form illness-desp">
      <!-- <div class="form-bg illness-desp-person arrow-right"> -->
      <div class="form-bg illness-desp-person" >
        <img src="../../assets/images/jidayi-hospital/icon_user.png" />
        <h2>咨询人</h2>
        <span>{{filterName(user.name)}}</span>
      </div>
      <div class="form-bg illness-desp-text">
        <div class="text-title">
          <h2>问题描述</h2>
          <span @click="selectDesc">历史描述</span>
        </div>
        <div class="textarea-wrap">
          <textarea
            name
            placeholder="请描述您的问题（最少输入10个字）"
            rows="8"
            maxlength="100"
            @blur.prevent="checkWxScroll()"
            @input="inputReplace"
            v-model="form.symptomDesc"
          ></textarea>
          <div class="textarea_counter">
            <span id="num">{{form.symptomDesc.length}}</span>/100
          </div>
        </div>
      </div>
      <div class="form-bg illness-desp-img">
        <div class="img-title">
          <h2>
            添加图片
            <span>(可选项，图片不超过9张)</span>
          </h2>
        </div>
        <div class="img-add">
          <ImageCard
            class="added"
            :file="file"
            v-for="(file,i) in filesArr"
            :isUpload="uploadArr[i]"
            :timestamp="timestamp"
            :progress="progressArr[i]"
            v-show="filesArr.length > 0"
            :key="typeof file === 'string'? file : i+file.lastModified"
            @remove="remove(i)"
          />
          <div class="add-btn" v-show="filesArr.length < 9">
            <input type="file" accept="image/*" multiple @change="addImage" />
            <img src="../../assets/images/jidayi-hospital/icon_addImg.png" />
          </div>
          <div class="add-tips" v-show="filesArr.length == 0">
            上传化验单、报告单、处方单、检查资料、患处照片(最多支持9张，每张不超10M)照片仅自己和医生可见照片
          </div>
        </div>
      </div>
    <!--  <div class="form-bg illness-desp-tip">
        <h2>温馨提示</h2>
        <p>如果没有医生回复的订单，系统将在24小时后自动取消咨询订单。</p>
      </div>-->
      <div class="agreement"><i class="icon-check" :class="{'checked':isAgree}" @click="isAgree = !isAgree"></i>我已阅读并同意<span @click="openAgreement()">《咨询服务须知》</span></div>
    </div>
    <div class="illness-filled"></div>
    <div class="illness-fixed-btn" id="fixed-bottom">
      <a :class="{active: formOk}" @click="checkIsReady">提交咨询</a>
    </div>
  </div>
</template>
<script>
import ImageCard from '@/components/common/ImageCard'
import util from '@/utils'
import Axios from 'axios'
import EXIF from '@/plugins/exif'
import api from '@/config/api'

export default {
  components: {
    ImageCard
  },
  data () {
    return {
      form: {
        consultType: "",
        symptomDesc: "",
        imgUrl: ""
      },
      isMini: false,
      filesArr: [],
      progressArr:[],
      uploadArr:[],
      base64Arr: [],
      isUpload: false,
      timestamp:0,
      isAgree: true,
      isConsult: "0" //业务类型（问诊or复诊）
    };
  },
  created() {
    // Object.assign(this.form, this.$route.query);
    this.isMini = this.$store.getters.platform === "mp" ? true : false;
    this.isConsult = this.$route.query.isConsult || "0";
    if (this.$route.query.isConsult === "1") {
      window.document.title = "在线复诊";
    } else {
      if(this.$store.getters.platId == 'T2021052404340500001'){
        window.document.title = "健康咨询";
      }else{
        window.document.title = "医生咨询";
      }
    }
    this.init();
    this.getConsultAgreement();
    if (!this.isMini) {
      util.wxSDKConfig();
    }
    console.log(this.form);
  },
  mounted() {
    //
    // const clientHeight = document.documentElement.clientHeight
    // window.addEventListener('resize', () => {
    //   const bodyHeight = document.documentElement.clientHeight
    //   const ele = document.getElementById('fixed-bottom')
    //   if (!ele) return
    //   if (clientHeight > bodyHeight) {
    //     ele.style.display = 'none'
    //   } else {
    //     ele.style.display = 'block'
    //   }
    // })
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo.user;
    },
    formOk() {
      if (this.isConsult == 1) {
        return !this.isUpload;
      } else {
        return this.form.symptomDesc && !this.isUpload;
      }
    }
  },
  methods: {
    init() {
      let {
        deptId,
        deptName,
        doctorId,
        doctorName,
        doctorProfessional,
        hospId,
        hospName,
        money,
        consultType,
        resTime,
        numberId,
        lockType
      } = { ...this.$route.query };
      const tempForm = {
        deptId: deptId || "",
        deptName: deptName || "",
        doctorId: doctorId || "",
        doctorName: doctorName || "",
        doctorProfessional: doctorProfessional || "",
        hospId: hospId || "",
        hospName: hospName || "",
        money: money || "",
        consultType: consultType || "",
        resTime: resTime || "",
        numberId: numberId || "",
        lockType: lockType,
        isConsult: this.isConsult
      };
      let desc = sessionStorage.getItem("HISTORY-DESC-ITEM");
      desc = (desc && JSON.parse(desc)) || {};
      tempForm.symptomDesc = desc.symptomDesc || "";
      tempForm.imgUrl = desc.imgUrl || "";
      this.form = tempForm;
      // 展示图片
      if (tempForm.imgUrl) {
        const imgUrlArr = tempForm.imgUrl.split(",");
        imgUrlArr.forEach(item => {
          this.filesArr.push(item);
          this.progressArr.push(0);
          this.uploadArr.push(false);
        });
      }
    },
    async getConsultAgreement() {
      let res = await this.$http.userAgreement({
        userType: "01",
        agreementType: "2"
      });
      this.agreement = res;
    },
    async openAgreement() {
      if (this.agreement.content) {
        this.$messagebox.alert(this.agreement.content, this.agreement.title);
      }
    },
    async checkIsReady() {
      if (!this.formOk) {
        return;
      }
      this.form.symptomDesc = this.form.symptomDesc.replace(
        /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g,
        ""
      ); //过滤emoj表情
      if (this.isConsult != "1" && this.form.symptomDesc.length < 10) {
        this.$toast("病症描述不能少于10个字！");
        return;
      }
      if (!this.isAgree) {
        this.$toast("请勾选咨询服务须知！");
        return;
      }
      let isAgreed = localStorage.getItem("CONSULT-AGREEMENT-FLAG");
      if (!isAgreed && this.agreement.content) {
        this.$messagebox.confirm("", {
          message: this.agreement.content,
          title: this.agreement.title,
          confirmButtonText: "不再提示",
          cancelButtonText: "下次提醒我"
        }).then(action => {
          localStorage.setItem("CONSULT-AGREEMENT-FLAG", "1")
          this.submit();
        }).catch(err => {
          this.submit();
        });
      } else {
        this.submit();
      }
    },
    async submit() {
      await this.uploadImages();

      this.$http.submitCounsulation(this.form).then(res => {
        if (res.status == "0") {
          if (this.isMini && api.version !== 'fever') {
            // 跳小程序支付页面
            var _urlParam = {
              money: this.form.money,
              consultType: this.form.consultType,
              orderNo: res.orderNo,
              numberId: this.form.numberId,
              type: "1",
              sessionId: this.$store.getters.token,
              payType: "03"
            };

            wx.miniProgram.navigateTo({
              url: "/pages/cashier/main?urlParam=" + JSON.stringify(_urlParam)
            });
          } else {
            this.$router.push({
              name: "payment",
              query: {
                ...this.form,
                orderNo: res.orderNo,
                type: "1"
              }
            });
          }
        } else if (res.status == "4") {
          if (this.isMini && api.version !== 'fever') {
            //如果是预约到订单列表
            if (this.form.numberId) {
              wx.miniProgram.redirectTo({
                url: "/pages/recordList/main?userType=01"
              });
            } else {
              wx.miniProgram.redirectTo({
                url: "/pages/imChat/main?userType=01&orderNo=" + res.orderNo
              });
            }
          } else {
            this.$router.push({
              path: "/imChat",
              query: { userType: "01", orderNo: res.orderNo }
            });
          }
        } else {
          // 1有存在一条为支付的咨询记录，2存在一条在等待中的咨询记录，3存在一天咨询中的咨询记录
          this.$toast(res.msg);
        }
        sessionStorage.removeItem("HISTORY-DESC-ITEM")
      });
    },
    async addImage(e) {
      const files = e.target.files;
      const imgsType = ["image/jpeg", "image/png", "image/gif"];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const isImg = imgsType.includes(file.type);
        const isLt1M = file.size / 1024 / 1024 < 1;
        const isGr8M = file.size / 1024 / 1024 > 10;
        if (!isImg) {
          this.$toast("上传图片只能是 JPG/PNG/GIF 格式!");
          return;
        }
        if (this.filesArr.length > 8) {
          this.$toast("上传图片数量不能超过9张!");
          return;
        }
        if (isGr8M && isImg) {
          this.$toast("上传图片大小不能超过10MB!");
          return;
        } else if (!isLt1M && isImg) {
          await this.compressImg(file);
        } else {
          // 小于1.5MB
          this.filesArr.push(file);
          this.progressArr.push(0);
          this.uploadArr.push(false);
        }
      }
      console.log("this.filesArr", this.filesArr);
      console.log("this.filesArr.len", this.filesArr.length);
      console.log("this.isUpload", this.isUpload);
    },
    remove(index) {
      this.filesArr.splice(index, 1);
      this.progressArr.splice(index, 1);
      this.uploadArr.splice(index, 1);
      console.log("this.fileArr", this.filesArr);
    },
    selectDesc() {
      const desc = {
        symptomDesc: this.form.symptomDesc
      }
      sessionStorage.setItem("HISTORY-DESC-ITEM", JSON.stringify(desc))
      this.$router.push({ name: "historyDescs", query: this.form });
    },
    compressImg(file) {
      return new Promise((resolve, reject)=>{
        console.log("compressImg", file);
        let reader = new FileReader();
        let img = new Image();
        let Orientation = null;
        EXIF.getData(file, function() {
          Orientation = EXIF.getTag(this, "Orientation");
        });
        reader.readAsDataURL(file);
        reader.onload = e => {
          img.src = e.target.result;
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let res = "";
          img.onload = () => {
            const originWidth = img.width;
            const originHeight = img.height;
            // 最大尺寸限制
            const maxWidth = 1000,
              maxHeight = 1000;
            // 目标尺寸
            let targetWidth = originWidth,
              targetHeight = originHeight;
            // 图片尺寸超过400x400的限制
            if (originWidth > maxWidth || originHeight > maxHeight) {
              if (originWidth / originHeight > maxWidth / maxHeight) {
                // 更宽，按照宽度限定尺寸
                targetWidth = maxWidth;
                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
              } else {
                targetHeight = maxHeight;
                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
              }
            }
            // canvas对图片进行缩放
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            if (Orientation && Orientation != 1) {
              switch (Orientation) {
                case 6:
                  canvas.width = targetHeight;
                  canvas.height = targetWidth;
                  context.rotate(Math.PI / 2);
                  context.drawImage(img, 0, -targetHeight, targetWidth, targetHeight);
                  break;
                case 3:
                  context.rotate(Math.PI);
                  context.drawImage(img, -targetWidth, -targetHeight, targetWidth, targetHeight);
                  break;
                case 8:
                  canvas.width = targetHeight;
                  canvas.height = targetWidth;
                  context.rotate((3 * Math.PI) / 2);
                  context.drawImage(img, -targetWidth, 0, targetWidth, targetHeight);
                  break;
              }
            } else {
              context.drawImage(img, 0, 0, targetWidth, targetHeight);
            }
            // 转base64
            // res = canvas.toDataURL("image/png")
            // this.filesArr.push(res)
            // 转blob
            res = canvas.toBlob(blob => {
              let _file = new File([blob], file.name, {
                type: file.type,
                lastModified: Date.now()
              });
              this.filesArr.push(_file);
              this.progressArr.push(0);
              this.uploadArr.push(false);
              console.log("now this.filesArr", this.filesArr);
              resolve(_file)
            });
          };
        };
      })

    },
    async uploadImages() {
      this.form.imgUrl = "";
      let resArr = [];
      var count = 0;
      for(var i in this.uploadArr){
        this.uploadArr[i] = true;
      }
      this.timestamp = new Date().getTime()
      for (let i in this.filesArr) {
        // 是否是图片文件
        if (typeof this.filesArr[i] === "object") {
          this.isUpload = true;
          await this.upload(i).then(res => {
            count++;
            resArr.push(res.url);
            this.uploadArr[i] = false;
            this.timestamp = new Date().getTime()
            if(count == this.filesArr.length){
              this.isUpload = false;
            }
          });
        } else {
          resArr.push(this.filesArr[i]);
        }
        console.log(typeof this.filesArr[i]);
      }
      this.form.imgUrl = resArr.join(",");
      console.log("this.form.imgUrl", this.form.imgUrl);
    },
    async upload(i) {
      let file = this.filesArr[i];
      return await new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("file", file); //this.dateUrlToBlob(file)
        Axios({
            url:"/api/file/upload",
            method:'post',
            onUploadProgress:progressEvent=>{ //原生获取上传进度的事件
              //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
              //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
              if(progressEvent.lengthComputable){
                this.progressArr[i] = progressEvent.loaded/progressEvent.total
                this.timestamp = new Date().getTime()
              }
            },
            data:formData
          })
          .then(res => {
            return resolve(res);
          })
          .catch(res => {
            return reject();
          });
      });
    },
    //姓名脱敏处理
    filterName(str) {
      let tempStr = "";
      if (null != str && str != undefined) {
        if (str.length < 3) {
          tempStr = "*" + str.substring(1, str.length);
          return tempStr;
        } else if (str.length >= 3 && str.length <= 6) {
          // tempStr = "**" + str.substring(2,str.length);
          tempStr =
            str.substring(0, 1) +
            str.substring(1, str.length - 1).replace(/[\s\S]/gi, "*") +
            str.substring(str.length - 1, str.length);
          return tempStr;
        } else if (str.length > 6) {
          tempStr = str.substring(0, 2) + "****" + str.substring(6, str.length);
          return tempStr;
        }
      } else {
        return "";
      }
    },
    inputReplace(){
      var regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
      this.form.symptomDesc = this.form.symptomDesc.replace(regStr, '');
    },
    //  绑定textarea的失焦事件
    checkWxScroll() {
      var ua = navigator.userAgent.toLowerCase();
      var u = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (ua.match(/MicroMessenger/i) == "micromessenger" && !!u) {
        var currentPosition, timer;
        var speed = 0; //页面滚动距离
        timer = setInterval(function() {
          currentPosition =
            document.documentElement.scrollTop || document.body.scrollTop;
          currentPosition -= speed;
          window.scrollTo(0, currentPosition); //页面向上滚动
          currentPosition += speed; //speed变量
          window.scrollTo(0, currentPosition); //页面向下滚动
          clearInterval(timer);
        }, 1);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/counsulation.vue